import React, { useState, useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import { scrollToSection } from "../../utilities/commonUtils";
import "./AboutMe.css";

const importAllImages = (requireContext) => {
  return requireContext
    .keys()
    .sort((a, b) => {
      const aMatch = a.match(/image(\d+)/i);
      const bMatch = b.match(/image(\d+)/i);
      if (aMatch && bMatch) {
        return Number(aMatch[1]) - Number(bMatch[1]);
      }
      return a.localeCompare(b);
    })
    .map((key) => {
      const image = requireContext(key);
      return image && image.default ? image.default : image;
    });
};

const carouselImages = importAllImages(
  require.context("../../assets/AboutMe/carousel", false, /\.(png|jpe?g|svg)$/)
);

export default function AboutMe(props) {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  // Carousel images array is loaded dynamically from the folder

  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreens(props.id);
  };
  // eslint-disable-next-line no-unused-vars
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === carouselImages.length - 1 ? 0 : prevIndex + 1
        );
      }, 1000); // Change image every 1 second

      return () => clearInterval(interval);
    }
  }, [isPaused]);

  return (
    <div
      className="about-me-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="about-me-parent">
        <ScreenHeading title={"About Me"} subHeading={"Why Choose Me?"} />
        <div className="about-me-card">
          <div
            className="about-me-profile"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            <img
              src={carouselImages[currentImageIndex]}
              alt="Profile"
              className="carousel-image"
            />
            <div className="carousel-dots">
              {carouselImages.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === currentImageIndex ? "active" : ""}`}
                  onClick={() => setCurrentImageIndex(index)}
                ></span>
              ))}
            </div>
          </div>
          <div className="about-me-details">
            <div className="about-me-description">
              <p>
                I am a B.Tech Computer Science (Artificial Intelligence) undergraduate at Indira Gandhi Delhi Technical University for Women (IGDTUW), driven by curiosity and a strong interest in building meaningful, real-world technology. I enjoy approaching problems with an engineering mindset—breaking them down, understanding the underlying logic, and designing solutions that are practical and scalable.
              </p>
              <p>
                I believe in learning by building. Through hands-on work, I focus on transforming ideas into well-structured systems while maintaining clarity, efficiency, and purpose in my approach. I value ownership, consistency, and thoughtful execution, and I enjoy collaborating in team environments where ideas are shared and refined.
              </p>
              <p>
                Beyond technical growth, I emphasize clear communication, time management, and adaptability. I am always eager to learn, explore new domains, and contribute to projects that create real impact through technology.
              </p>
              <p className="cgpa-text">
                CGPA: <span className="cgpa-highlight">9.58/10</span>
              </p>
            </div>
            <div className="about-me-options">
              <button
                className="btn primary-btn"
                onClick={() => scrollToSection("Contact Me")}
              >
                {" "}
                Get In Touch{" "}
              </button>
              <a
                href="https://drive.google.com/file/d/1X5ixtIuUrVezV_quhXmX67ZWmA3zNxVW/view?usp=drive_link"
              >
                <button className="btn highlighted-btn">My Resume</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}